/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIGuestUser } from './APIGuestUser';
import {
    APIGuestUserFromJSON,
    APIGuestUserFromJSONTyped,
    APIGuestUserToJSON,
} from './APIGuestUser';

/**
 * 
 * @export
 * @interface APIPaginatedGuestUserList
 */
export interface APIPaginatedGuestUserList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedGuestUserList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedGuestUserList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedGuestUserList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIGuestUser>}
     * @memberof APIPaginatedGuestUserList
     */
    results: Array<APIGuestUser>;
}

/**
 * Check if a given object implements the APIPaginatedGuestUserList interface.
 */
export function instanceOfAPIPaginatedGuestUserList(value: object): value is APIPaginatedGuestUserList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedGuestUserListFromJSON(json: any): APIPaginatedGuestUserList {
    return APIPaginatedGuestUserListFromJSONTyped(json, false);
}

export function APIPaginatedGuestUserListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedGuestUserList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIGuestUserFromJSON)),
    };
}

export function APIPaginatedGuestUserListToJSON(value?: APIPaginatedGuestUserList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIGuestUserToJSON)),
    };
}

